import { CreateTradingPortfolioBidResponse } from '~/networking/api/trading/responses';
import { type MakeMangedRequestOptions } from '~/networking/client/VinovestNetworkingClient';
import { httpRequest, Response } from '~/networking/utils/httpRequest';
import type { VinovestMoney } from '~/constants/money';

export interface CreateTradingPortfolioBidOptions {
    productId: number;
    price: VinovestMoney;
    /** quantity of the trade */
    quantity: number;
}

export const createTradingPortfolioBid =
    ({ getHeaders, getPortfolioId, getRequestUrl }: MakeMangedRequestOptions) =>
    async (postBody: CreateTradingPortfolioBidOptions): Promise<Response<CreateTradingPortfolioBidResponse>> => {
        const url = getRequestUrl(`/v1/markets/portfolio/${getPortfolioId()}/bids`);
        return httpRequest.post(url, { headers: getHeaders(true), body: postBody });
    };
